module.exports = __webpack_public_path__ + "img/logo-light.f5b72c53.svg";